import { render } from "./BuddyInfoOverlay.vue?vue&type=template&id=e00dbfa0&scoped=true"
import script from "./BuddyInfoOverlay.vue?vue&type=script&lang=js"
export * from "./BuddyInfoOverlay.vue?vue&type=script&lang=js"

import "./BuddyInfoOverlay.vue?vue&type=style&index=0&id=e00dbfa0&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00dbfa0"]])

export default __exports__